import {map} from 'rxjs/operators';

export interface RcCorps {
    idCorps: any;
    codeCorps: string;
    libelleCorps: string;
}

export interface Rc {
    idFonction: any;
    libelleFonction: string;
    codeFonction: string;
}

export interface ServerResponse {
    code: string;
    payload: any;
    message: string;
}

export interface Response<T> {
    code: string;
    payload: T;
    message: string;
    total?: any;
}

export function body(observable) {
    return observable.pipe(map((response: any) => response.payload));
}

export interface Movement {
    idTypeMouvement: any;
    idEtatMouvement: any;
    dateFinDepot: any;
    libelleMvt: string;
    dateOuverture: any;
    anneeScolaire: string;
    etatFr: string;
    idMvt: any;
    idMouvement: any;
    idCorps: number[];
    description: string;
    etatAr: string;
    dateDebutDepot: any;
    codeMvt: string;
    dateCloture: any;
    nbChoixMax: number;
    nbChoixMin: number;
    codeTypMvt: string;
    nbChoixCre: number;
    idTypeMvt?: any;
    dateReference?: any;
    url?: string;
    etatMouvementAR: string;
    etatMouvementFR: string;
    idMouvementParent: any;
    flgMinTemp: boolean;
    flValid: boolean;
    flgResPrim: boolean;
}

export interface Offre {
    epBidMasterId?: number;
    bidNo?: string;
    bidModSeq?: string;
    regType?: string;
    realYn?: string;
    onOffType?: string;
    refNo?: string;
    planNo?: string;
    planModSeq?: string;
    bidInstCd?: string;
    bidNmAr?: string;
    bidNmFr?: string;
    bidNmEn?: string;
    bizKind?: string;
    procedureType?: string;
    internationalBidYn?: string;
    frameworkYn?: string;
    generalYn?: string;
    financingYn?: string;
    financialMethod?: string;
    priceType?: string;
    guaranteeType?: string;
    bidExpiredDays?: string;
    executionPlace?: string;
    evalMethod?: string;
    techEvalRate?: string;
    finaEvalRate?: string;
    passScore?: string;
    consorYn?: string;
    pqRecvEndDt?: any;
    pqOpenDt?: any;
    pqRecvAddrsAr?: string;
    pqRecvAddrsFr?: string;
    pqRecvAddrsEn?: string;
    tpRecvEndDt?: any;
    tpOpenDt?: any;
    tpRecvAddrsAr?: string;
    tpRecvAddrsEn?: string;
    tpRecvAddrsFr?: string;
    bdRecvStartDt?: string;
    bdRecvEndDt?: any;
    bdOpenDt?: any;

    biddingDocPriceCurr?: string;
    biddingDocPlace?: string;
    bdDepartAr?: string;
    bdDepartFr?: string;
    bdDepartEn?: string;
    bdRecvAddrsAr?: string;
    bdRecvAddrsFr?: string;
    bdRecvAddrsEn?: string;
    examChmanId?: string;
    procChmanId?: string;
    publicDt?: Date;
    publicYn?: string;
    regDt?: any;
    regId?: string;
    encCert?: string;
    guarFixedAmount?: string;
    regevalTypeId?: string;
    guarCurr?: string;
    guarType?: string;
    participation?: string;
    controlId?: string;
}

export interface vappeloffre {
    bizKindStrFr?: string;
    bizKindStrEn?: string;
    bizKindStrAr?: string;
    bizKindStrId?: string;
    bdRecvEndDt_end: Date;
    publicDt_end: Date;
    techEvalRate?: string;
    passScore?: string;
    pqRecvEndDt?: string;
    pqOpenDt?: string;
    tpRecvEndDt?: string;
    tpOpenDt?: string;
    finaEvalRate?: string;
    regDt?: string;
    guarFixedAmount?: string;
    regevalTypeId?: string;
    guarCurr?: string;
    guarType?: string;
    controlId?: string;
    participation?: string;
    bdRecvEndDt: Date;
    biddingDocPriceCurr: string;
    encCert: string;
    generalYn: string;
    bdRecvStartDt: Date;
    bidNo?: string;
    guaranteeTypeStrFr: string;
    procedureTypeStrEn: string;
    executionPlaceStrEn: string;
    pbkStrAr: string;
    realYnStrFr: string;
    financialMethodStrEn: string;
    biddingDocPrice: number;
    realYn: string;
    bdOpenDt: Date;
    bidNmAr: string;
    onOffTypeStrEn: string;
    priceTypeStrFr: string;
    internationalBidYnStrAr: string;
    onOffType: string;
    consorYn: string;
    regTypeStrFr: string;
    procedureTypeStrFr: string;
    priceTypeStrEn: string;
    internationalBidYnStrId: number;
    financialMethodStrFr: string;
    bdDepartEn: string;
    bidExpiredDays: string;
    consorYnStrFr: string;
    publicYn: string;
    evalMethodStrAr: string;
    tpRecvAddrsFr: string;
    executionPlace: string;
    bidInstNm: string;
    bdRecvStartDtStr: string;
    regTypeStrAr: string;
    bdRecvAddrsEn: string;
    staffNm: string;
    financingYn: string;
    regType: string;
    consorYnStrEn: string;
    internationalBidYn: string;
    realYnStrEn: string;
    examChmanIdStr: string;
    priceType: string;
    executionPlaceStrFr: string;
    bdOpenDtStr: string;
    planModSeq: string;
    frameworkYn: string;
    bdDepartFr: string;
    evalMethodStrId: number;
    pqRecvAddrsEn: string;
    bizKind: string;
    tpRecvAddrsEn: string;
    bidModSeq: string;
    guaranteeTypeStrId: number;
    bidNmFr: string;
    regTypeStrId: number;
    bdRecvAddrsFr: string;
    procedureTypeStrId: number;
    financialMethodStrId: number;
    internationalBidYnStrFr: string;
    pbkStrEn: string;
    onOffTypeStrId: number;
    epBidMasterId: number;
    pqRecvAddrsFr: string;
    bdDepartAr: string;
    bidNmEn: string;
    financialMethod: string;
    onOffTypeStrAr: string;
    procedureTypeStrAr: string;
    executionPlaceStrAr: string;
    guaranteeTypeStrAr: string;
    financialMethodStrAr: string;
    pbkStrFr: string;
    evalMethodStrFr: string;
    bidPoCd: string;
    internationalBidYnStrEn: string;
    bdRecvEndDtStr: string;
    priceTypeStrId: number;
    guaranteeType: string;
    priceTypeStrAr: string;
    regId: string;
    publicDtStr: string;
    executionPlaceStrId: number;
    evalMethod: string;
    procedureType: string;
    refNo: string;
    publicDt: Date;
    regTypeStrEn: string;
    consorYnStrId: number;
    biddingDocPlace: string;
    bdRecvAddrsAr: string;
    procChmanIdStr: string;
    consorYnStrAr: string;
    realYnStrId: number;
    pqRecvAddrsAr: string;
    realYnStrAr: string;
    examChmanId: string;
    guaranteeTypeStrEn: string;
    procChmanId: string;
    planNo: string;
    tpRecvAddrsAr: string;
    bidInstCd: string;
    pbkStrId: number;
    onOffTypeStrFr: string;
    evalMethodStrEn: string;
    publicYnStrFr: string;
    publicYnStrAr: string;
    publicYnStrEn: string;
}

export interface vProjetProg {
    planNmAr: string;
    epPlanMasterId: number;
    bizKindNmEn: string;
    planNmFr: string;
    planModSeq: string;
    bizKindNmId: number;
    planNmEn: string;
    bizKind: string;
    smallBizYn: string;
    planNo: string;
    instNm: string;
    bizKindNmFr: string;
    bizKindNmAr: string;
    pbkStrAr: string;
    pbkStrFr: string;
    pbkStrEn: string;
    publicDt_end: Date;
    pbkStrId: number;
    executionPlaceStrAr: string;
    executionPlaceStrFr: string;
    executionPlaceStrEn: string;
    executionPlaceStrId: number;
    financialMethodStrAr: string;
    financialMethodStrFr: string;
    financialMethodStrEn: string;
    financialMethodStrId: string;
    publicDt: string;
    bidExecutionExpDt: string;
    planYear: string;
    biddingDocExpDt: string;
    procCommissionExpDt: string;
    bidPublicExpDt: string;
    procedureTypeStrFr: string;
    procedureTypeStrAr: string;
    procedureTypeStrEn: string;
    procedureTypeStrId: string;
    publicYn: string;
    publicYnStrEn: string;
    publicYnStrFr: string;
    publicYnStrAr: string;
}

export interface vconsultation {
    bizKindCd: string;
    pbkStrFr: string;
    shopInstCd: string;
    bizKindStrEn: string;
    publicDt: Date;
    spRecvEndDt: Date;
    publicYn: string;
    shopModSeq: string;
    pbkStrEn: string;
    bizKindStrFr: string;
    cdNmAr: string;
    shopNmFr: string;
    bizKindStrAr: string;
    pbkStrAr: string;
    shopNmAr: string;
    spShopMasterId: number;
    instNm: string;
    bizKindStrId: number;
    spRecvEndDtStr: string;
    shopNmEn: string;
    pbkStrId: number;
    publicDtStr: string;
    cdNmFr: string;
    shopNo: string;
    cdNmEn: string;
    epFr: string;
    epAr: string;
    epEn: string;
    spRecvStartDt: Date;
    spOpenDt: Date;
    shopExpiredDays: number;
    regId: string;
    regNm: string;
    examId: string;
    examNm: string;
    bcId: string;
    bcNm: string;
    instNmAr?: string;
    instNmEn?: string;
    affectationcheck?: string;
    internationalShopYn?: string;
    spRecvEndDtStr_end: Date;
    masterCdExam: string;
    masterCdBc: string;
    emailInst: string;
    refNo?: string;

}

export interface vOuverturesOffres {
    cdNmStrEn: string;
    procedureType: string;
    refNo: string;
    bidNo: string;
    nbCandidature: number;
    procedureTypeStrEn: string;
    epBidMasterId: number;
    bidNmEn: string;
    cdNmStrEvalFr: string;
    procedureTypeStrAr: string;
    cntOnbid: number;
    bdOpenDt: Date;
    bidNmAr: string;
    execType: string;
    bidCls: string;
    evalExecType: string;
    onOffType: string;
    cdNmStrFr: string;
    bdOpenDtStr: string;
    bizKind: string;
    procedureTypeStrFr: string;
    cdNmStrEvalAr: string;
    bidInstCd: string;
    bidModSeq: string;
    cdNmStrAr: string;
    regId: string;
    cdNmStrEvalEn: string;
    bidNmFr: string;
    evalMethod: string;
    pqOpenDt: string;
    tpOpenDt: string;
    internationalBidYn: string;
}

export interface vEvaluationOffre {
    bidCls: string;
    bidModSeq: string;
    bidNmAr: string;
    bidNmEn: string;
    bidNmFr: string;
    bidNo: string;
    evalMethod: string;
    examChmanId: string;
    execType: string;
    execTypeStrAr: string;
    execTypeStrEn: string;
    execTypeStrFr: string;
    id: number;
    openResultPublicDt: string;
    openResultPublicDtStr: string;
    procedureType: string;
    procedureTypeStrAr: string;
    procedureTypeStrEn: string;
    procedureTypeStrFr: string;
    refNo: string;
    regId: string;
}

export interface Acheteur {
    upperInstCd: string;
    lvl: string;
    instNmEn: string;
    umInstCodeId: string;
    instNmAbbrAr: string;
    nisCd: string;
    instAffiche: number;
    instNmAbbr: string;
    instPublic: string;
    instNm: string;
    instCd: string;
    hasChild: string;
    instNmAr: string;
    instNmAbbrEn: string;
    motcle?: string;
}

export interface Lot {
    budgetAmt?: number;
    guaranteeAmountCurr?: string;
    bidClsDtlDesc?: string;
    bidClsNm?: string;
    bidModSeq?: string;
    bidNo?: string;
    guaranteeAmount: number;
    bidCls?: string;
    epBidClsId?: number;
    budgetAmtCurr?: string;
}

export interface Certificat {
    domainName: string;
    commonName: string;
    keyUsages: string;
    issuerDomainName: string;
    issuerCommonName: string;
    notBefore: Date;
    notAfter: Date;
    notBeforeDt: Date;
    notAfterDt: Date;
    alias: string;
}

export interface LotConsultation {
    budgetAmt?: string;
    shopCls?: string;
    shopClsDtlDesc?: string;
    shopModSeq?: string;
    guaranteeAmountCurr?: string;
    guaranteeAmount?: string;
    shopNo?: string;
    budgetAmtCurr?: string;
    shopClsNm?: string;
    spShopClsId?: number;
}

export interface Participation {
    budgetAmt?: number;
    licenseCd?: string;
    bidLicenseCd?: string;
    bidModSeq?: string;
    bidNo?: string;
    epBidLicenseId?: number;
    bidCls?: string;
    seq?: string;
}

export interface Infoprod {
    epBidClsDtlId?: number;
    bidNo?: string;
    bidModSeq?: string;
    bidCls?: string;
    seqNo?: string;
    cateId?: number;
    cateNm?: string;
    qty?: number;
    unit?: string;
    deliveryEndDtStr?: Date;
    deliveryDays?: string;
}

export type MovementResponse = ServerResponse & {
    payload: Movement[];
};

export function inDeposit(movement: Movement) {
    return movement.etatFr === 'depot candidature';
}

export type Nullable<T> = T | null;

export class UserCertifLogin {
    userId: string = '';
    userCl: string = '';
    masterCd: string = '';
    staffNm: string = '';
    positionNm: string = '';
    staffDeptNm: string = '';
    mtelNo: string = '';
    telNo: string = '';
    faxNo: string = '';
    email: string = '';
    delFl: string = '';
    regDt: Date = new Date();
    modDt: Date = new Date();
    testFl: string = '';
    umLgLoginQVO: UmLgLoginQVO = new UmLgLoginQVO();
    userDN: string = '';
    logNum: string = '';
    clientIp: string = '';
    slt: string = '';
    sltk: string = '';
    slts: string = '';
    targetUrl: string = '';
    version: string = '';
    encData?: string;
    secu?: string;
    fail?: string;
    staffDepNm?: string;
    supplierNm?: string;
    seq?: string;
}

export class UmLgLoginQVO {
    userId: string = '';
    userCl: string = '';
    masterCd: string = '';
    supplierNm: string = '';
    staffDeptNm: string = '';
    staffNm: string = '';
    seq: string = '';
    testFl: string = '';
    authCd: string = '';
    authCdStr: string = '';
    unicodeKey: string = '';
}

export interface InfoOs {
    name: string;
    os: string;
    version: string;
    pkcs11: null;
}
